import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import useGarbageCollector from '../../../../libs/garbagecollector/garbageCollectorHooks';
import Breadcrumbs from '../../../components/breadcrumbs/Breadcrumbs';
import { FORM_SECTION_ROUTES } from '../constants';
import { setFinalSaveSingleFormData, setSaveSingleFormSuccessData } from '../FormsSectionSlice';
import { componentKey } from './CreateFormSlice';
import CreateFormStepper from './createformstepper/CreateFormStepper';
import SelectYearFormType from './selectyearformtype/SelectYearFormType';
import styles from './CreateForm.styles';
import { PAGE_PATH, PAGE_PERMISSIONS } from '../../dashboard/constants/constant';
import { PermissionReroute, useUserPermissionsInfo } from '../../dashboard/hooks/userHooks';
import useTxNavigate from '../../../../libs/txnavigate/TxNavigateHook';

export default function CreateForm(){
    useGarbageCollector(componentKey);
    const { isYearFormTypeSelected } = useSelector((state) => state[componentKey]);
    const dispatch = useDispatch();
    const navigate = useTxNavigate();
    const { permissions } = useUserPermissionsInfo();

    useEffect(()=>{
        PermissionReroute(PAGE_PERMISSIONS.CREATE_FORM, permissions, navigate, PAGE_PATH.DASHBOARD)
    },[permissions])

    useEffect(() => {
        dispatch(setSaveSingleFormSuccessData(null));
        dispatch(setFinalSaveSingleFormData({}));
    }, []);

    return <>
        <div>
            {/* <div style={styles.mainContainer}> */}
                <Breadcrumbs items={[
                        { text: 'Home', link: '/' },
                        { text: 'Forms', link: `/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.LISTING}/${FORM_SECTION_ROUTES.FORM1099}` },
                        { text: 'Create Form' },
                    ]} 
                />
                {
                    !isYearFormTypeSelected ? <SelectYearFormType /> : <CreateFormStepper />
                }
            {/* </div> */}
        </div>
    </>
}